import React, { useContext } from 'react';
import { AppConfigContext } from '@providers/AppConfigProvider';

type ImageProps = {
  id: string;
  image_url: {
    '2xl': string;
    lg: string;
    md: string;
    original: string;
    sm: string;
    xl: string;
    xs: string;
  };
  title: string;
  sort_id: number;
  image_branch_id: number;
  is_main: number;
  is_deleted: number;
  image_table_name: string;
  created_at: string;
  updated_at: string;
};

type ImagePathProps = {
  images: ImageProps[];
};

export default function DefaultImage(props: ImagePathProps): React.JSX.Element {
  const { images } = props;
  const { isMobile } = useContext(AppConfigContext);
  let newSrc = images[0].image_url['2xl'];
  if (isMobile) {
    newSrc = images[0].image_url.xl;
  }

  return (
    <section className="py-3 max-md:py-2 rounded">
      <img
        src={newSrc}
        alt="物件画像は準備中です"
        className="md:max-w-7xl w-full mx-auto max-h-96 max-md:max-h-80 md:px-24 aspect-video object-cover"
        width="110"
        height="38"
      />
    </section>
  );
}
